export default "__VITE_ASSET__VkG0Hh7H__"